import { useOutletContext } from 'react-router-dom';

import type { ToastSeverity } from '../../lib/useToast';
import { ApprovalQueuePanel } from '../components/ApprovalQueuePanel';
import { BudgetsPanel } from '../components/BudgetsPanel';
import { CampaignCalendarPanel } from '../components/CampaignCalendarPanel';
import { CouponsListPanel } from '../components/CouponsListPanel';
import { ProductSetsPanel } from '../components/ProductSetsPanel';
import { PromoSettingsPanel } from '../components/PromoSettingsPanel';
import { PromotionsListPanel } from '../components/PromotionsListPanel';

/**
 * Shared context `PromoWorkspacePage` (the tab shell) hands its routed children via `<Outlet
 * context>` — one `useToast`/`Snackbar` per workspace (plan-011 §7), not one per tab. Every tab
 * panel below stays a plain, directly-testable `onResult`-prop component (mirroring
 * `PriceApprovalsPanel`'s house pattern); these thin wrappers are the only place that reaches into
 * React Router's context mechanism, keeping that plumbing out of the panels themselves.
 */
export interface PromoOutletContext {
  onResult: (severity: ToastSeverity, message: string) => void;
}

function useOnResult() {
  return useOutletContext<PromoOutletContext>().onResult;
}

export function CampaignCalendarRoute() {
  return <CampaignCalendarPanel onResult={useOnResult()} />;
}

export function PromotionsListRoute() {
  return <PromotionsListPanel onResult={useOnResult()} />;
}

export function CouponsListRoute() {
  return <CouponsListPanel onResult={useOnResult()} />;
}

export function ProductSetsRoute() {
  return <ProductSetsPanel onResult={useOnResult()} />;
}

export function BudgetsRoute() {
  return <BudgetsPanel onResult={useOnResult()} />;
}

export function ApprovalQueueRoute() {
  return <ApprovalQueuePanel onResult={useOnResult()} />;
}

export function PromoSettingsRoute() {
  return <PromoSettingsPanel onResult={useOnResult()} />;
}
